import { targetedAnyAqlValuePattern } from '../../regexp'

export const prependAql = (prior: string, key: string, value: string): string => {
    if (!value) {
        return prior
    }

    if (!key) {
        return prior ? `${value} ${prior}` : value
    }

    return prior ? `${key}:${value} ${prior}` : `${key}:${value}`
}

export const appendAql = (prior: string, key: string, value: string): string => {
    if (!value) {
        return prior
    }

    if (!key) {
        return prior ? `${prior} ${value}` : value
    }

    return prior ? `${prior} ${key}:${value}` : `${key}:${value}`
}

export const removeAql = (prior: string, key: string): string => {
    if (!prior || !key) {
        return prior
    }

    const pattern = targetedAnyAqlValuePattern(key)
    const regex = new RegExp(pattern, 'i')

    return prior.replace(regex, '').trim()
}

export const replaceAql = (prior: string, oldKey: string, newKey: string, value: string): string => {
    if (!value) {
        return removeAql(prior, oldKey)
    }

    if (!prior || !oldKey || !newKey) {
        return prior
    }

    const pattern = targetedAnyAqlValuePattern(oldKey)

    const regex = new RegExp(pattern, 'i')
    const priorFound = regex.test(prior)

    return priorFound ? prior.replace(regex, ` ${newKey}:${value}`) : appendAql(prior, newKey, value)
}
